// extracted by mini-css-extract-plugin
export default {"spanNoOverFlow":"Survey_spanNoOverFlow__1DkJ3","surveyTableHeader":"Survey_surveyTableHeader__6RfL6"};